var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createContext, useMemo, useRef, useState } from "react";
import { useReload } from "./ReloadContext";
import { jsx as _jsx } from "react/jsx-runtime";
export const HwEditingContext = /*#__PURE__*/ createContext({ creating: null, editing: null, onCreate: hw => { throw new Error("no provider"); }, onEdit: hw => { throw new Error("no provider"); }, onDone: () => { throw new Error("no provider"); } });
export function HwEditingContextProvider(props) {
    const [creating, setCreating] = useState(null);
    const [editing, setEditing] = useState(null);
    useReload(() => { setEditing(null); setCreating(null); }, []);
    const lastIdRef = useRef(0);
    const ctx = useMemo(() => {
        return { creating: creating, editing: editing, onCreate: setCreating, onEdit: (hw) => __awaiter(this, void 0, void 0, function* () { lastIdRef.current = hw.id; setEditing(hw); }), onDone: () => {
                setEditing(null);
                setCreating(null); // set hash to id of editing item
                if (lastIdRef.current > 0) {
                    window.location.hash = makeHeadingId(lastIdRef.current);
                }
            } };
    }, [creating, editing]);
    return /*#__PURE__*/ _jsx(HwEditingContext.Provider, { value: ctx, children: props.children });
}
export function makeHeadingId(id) { return "hardware-group-" + id; }
